import { apiService } from './api.service';
import { CR_API_ENDPOINTS } from '../constants';
import { Combiner } from '../types';

class CombinersService {
  /**
   * Get all combiners, optionally filtered by inverter brand.
   * @param inverterBrandId - Optional UUID to filter by inverter brand
   * @returns Array of combiners
   */
  async getAll(inverterBrandId?: string): Promise<Combiner[]> {
    const params = inverterBrandId ? { inverterBrandId } : undefined;
    return apiService.get<Combiner[]>(CR_API_ENDPOINTS.COMBINERS, params);
  }

  /**
   * Create a new combiner linked to an inverter brand.
   * @param data - Combiner name and inverter brand ID
   * @returns The created combiner
   */
  async create(data: { name: string; inverter_brand_id: string }): Promise<Combiner> {
    return apiService.post<Combiner>(CR_API_ENDPOINTS.COMBINERS, data);
  }

  /**
   * Delete a combiner by ID.
   * @param id - UUID of the combiner to delete
   */
  async delete(id: string): Promise<void> {
    return apiService.delete<void>(`${CR_API_ENDPOINTS.COMBINERS}/${id}`);
  }
}

export const combinersService = new CombinersService();
